<template>
  <div>
    <section v-show="carregar">
      <loading />
    </section>
    <section class="pt-4 pb-5" v-show="!carregar">
      <div
        class="alert alert-warning border-0 text-center mt-1 align-items-center justify-content-center position-relative"
        role="alert"
        v-if="chamadoAberto"
        v-show="closeModal"
      >
        <i class="material-icons pr-2" style="font-size: 3em">info</i>
        <p class="message">
          Você possui uma solicitação de atualização de dados em aberto. Aguarde
          a conclusão para solicitar uma nova atualização.
        </p>
      </div>
      <div class="cadastroNaoAssociado">
        <div
          class="d-flex flex-column justify-content-between align-items-stretch"
        >
          <div class="row">
            <div class="col form_padrao">
              <Titulo
                title="Editar associado"
                description="Valide os dados do associado."
              />
              <div>
                <FormulateForm
                  name="Cadastro"
                  v-model="values"
                  @submit="salvarRegistro"
                >
                  <div class="row">
                    <div class="col-md-8">
                      <FormulateInput
                        type="text"
                        name="nomecomercial"
                        label="Nome Comercial"
                        validation="required"
                        readonly="true"
                      />
                    </div>
                    <div class="col-md-4">
                      <FormulateInput
                        type="select"
                        name="tP_EMPRESA"
                        :options="tipoEmpresa"
                        label="Tipo Empresa"
                        validation="required"
                        disabled="true"
                      />
                    </div>
                  </div>
                  <FormulateInput
                    type="text"
                    name="razaosocial"
                    label="Razão Social"
                    validation="required"
                    readonly="true"
                  />
                  <div class="row">
                    <div class="col-md-6">
                      <FormulateInput
                        type="text"
                        name="doc"
                        label="CPF/CPNJ"
                        validation="required"
                        v-mask="['###.###.###-##', '##.###.###/####-##']"
                        @change="validarCpf($event.target.value)"
                        readonly="true"
                      />
                    </div>
                    <div class="col-md-6">
                      <FormulateInput
                        type="text"
                        name="inscest"
                        label="Inscrição Estadual"
                        readonly="true"
                      />
                    </div>
                  </div>
                  <Endereco ref="enderecoRef" />
                  <div class="row">
                    <div class="col-md-6">
                      <FormulateInput
                        type="text"
                        name="telefone"
                        label="Telefone"
                        v-mask="'(##) ####-####'"
                      />
                    </div>
                    <div class="col-md-6">
                      <FormulateInput
                        type="email"
                        name="email"
                        label="Email"
                        validation="required|email"
                        readonly="readonly"
                      />
                    </div>
                  </div>

                  <div class="d-flex col-5 mt-5">
                    <button
                      type="submit"
                      class="btn btn-verde p-0"
                      :disabled="loading || chamadoAberto"
                    >
                      <span
                        class="spinner-grow spinner-grow-sm pr-2"
                        role="status"
                        aria-hidden="true"
                        v-show="loading"
                      ></span>
                      <span v-if="loading">Aguarde</span>
                      <span v-else>Salvar</span>
                    </button>
                  </div>
                </FormulateForm>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-5 flex-column-reverse flex-md-row">
        <div class="col-md-4 col-lg-2 mt-3 mt-md-0">
          <Botao
            title="Voltar"
            @click="$router.push({ name: 'painelAssociado' })"
            nameClass="btn btn-outline-secondary btn-lg btn-block"
            >VOLTAR</Botao
          >
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { clearStr, validateCPF } from "../../../helpers";
import Titulo from "@/components/TituloPaginas";
import Endereco from "@/components/cadastro/FormEndereco";
import Botao from "@/components/botoes/Botao";
export default {
  name: "Login",
  components: { Endereco, Titulo, Botao },
  data() {
    return {
      produto: {
        nome: "SPC Consultor",
        id: "spcConsultor",
      },
      breadcrumb: [
        {
          nome: "SPC Consultor",
          id: "spcConsultor",
          produto: "SPC Consultor",
        },
        {
          nome: "Editar Associado",
          id: "cadastrarAssociado",
          produto: "SPC Consultor",
        },
      ],
      tipoEmpresa: [
        {
          label: "Selecione",
          value: "",
        },
        {
          label: "Pessoa Jurídica",
          value: "PJ",
        },
        {
          label: "Associação ou Entidade",
          value: "AE",
        },
        {
          label: "Profissional Liberal",
          value: "PL",
        },
        {
          label: "Autônomo",
          value: "AUT",
        },
        {
          label: "MEI",
          value: "MEI",
        },
      ],
      tipoSexo: [
        {
          label: "Selecione",
          value: "",
        },
        {
          label: "Masculino",
          value: "M",
        },
        {
          label: "Feminino",
          value: "F",
        },
      ],
      planos: [
        {
          label: "Selecione",
          value: "",
        },
        {
          label: "Essencial",
          value: "0000283",
        },
        {
          label: "Prata",
          value: "0000335",
        },
        {
          label: "Ouro",
          value: "0000336",
        },
      ],
      values: {},
      loading: false,
      error: false,
      aceiteTermo: false,
      chamadoAberto: false,
      closeModal: true,
      carregar: true,
    };
  },
  methods: {
    validarCpf(cpfStr) {
      var cpf = clearStr(cpfStr);

      const result = validateCPF(cpf);
      if (!result) {
        this.invalidCpf = true;
        this.$formulate.handle(
          {
            inputErrors: { cpf: "CPF Inválido!" },
            hasErrors: { cpf: true },
          },
          "Cadastro"
        );
      } else {
        this.invalidCpf = false;
        this.$formulate.handle({ inputErrors: { cpf: null } }, "Cadastro");
      }
    },
    async salvarRegistro() {
      this.loading = true;
      var dadosForm = Object.assign({}, this.values);

      if (!sessionStorage.ip) {
        await fetch(process.env.VUE_APP_IP_API + "?format=json")
          .then((x) => x.json())
          .then(({ ip }) => {
            sessionStorage.ip = ip;
          });
      }

      dadosForm.cep = clearStr(dadosForm.cep);
      dadosForm.telefone = dadosForm.telefone
        ? clearStr(dadosForm.telefone)
        : "";

      const valuesFixos = {
        codSocio: this.codSocio,
        telefone: dadosForm.telefone,
        email: dadosForm.email,
        endereco:
          dadosForm.rua +
          ", " +
          dadosForm.numero +
          " " +
          dadosForm.complemento +
          " Bairro:" +
          dadosForm.bairro +
          " CEP:" +
          dadosForm.cep +
          " " +
          dadosForm.cidade +
          "/" +
          dadosForm.estado,
        origem: null,
      };

      const dados = { ...valuesFixos };

      await this.$http
        .post("api/Consultor/AtualizarCadastroAssociado", dados)
        .then((response) => {
          if (response.data.mensagem) {
            this.$toast.open({
              message: "Solicitação de atualização de dados com sucesso.",
              type: "success",
              duration: 4000,
            });
            //localStorage.setItem("associadoSelecionado", response.data.codSocio);
            this.$router.push({ name: "painelAssociado" });
          } else {
            this.loading = false;
            this.$toast.open({
              message: response.data.mensagem,
              type: "error",
              duration: 4000,
            });
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$toast.open({
            message: error.response.data.mensagem,
            type: "error",
            duration: 4000,
          });
        });
      this.error = false;
    },
  },
  created() {
    this.$store.commit("UPDATE_PRODUTO", this.produto);
    this.$store.commit("UPDATE_BREADCRUMB", this.breadcrumb);
    this.codSocio = localStorage.getItem("associadoSelecionado");

    this.$http
      .get(`api/Consultor/ConsultarAssociado?codSocio=${this.codSocio}`)
      .then((response) => {
        this.carregar = false;
        this.chamadoAberto = response.data.chamadoAtualizacao;
        this.values = response.data.dadosCadastrais;
        this.values.rua = response.data.dadosCadastrais.lograd;
        this.values.estado = response.data.dadosCadastrais.uf;
        this.values.telefone =
          response.data.dadosCadastrais.ddd +
          response.data.dadosCadastrais.telefone;
      })
      .catch((error) => {
        if (error.response.status === 401) {
          this.$router.push({ name: "login" });
        }

        this.carregar = false;
        this.loading = false;
        this.error = error.response.data.mensagem;
      });
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_mixins.scss";
@import "@/assets/scss/_vars.scss";
.cadastroNaoAssociado /deep/ {
  @import "@/assets/scss/_vue-formulate.scss";
  background: white;
  padding: 2rem;
  border-radius: 6px;
  .formulate-input {
    margin-top: 1rem;
    .formulate-input-wrapper {
    }
    .formulate-input-label {
      margin-bottom: 0.5rem;
    }

    .formulate-input-element {
      padding: 5px;
      background: $dark-100;
      input,
      select {
        background: $dark-100;
      }
    }
    &[data-classification="select"] {
      select {
        width: 100%;
        height: 100%;
      }
    }
    &[data-classification="button"] {
      &,
      .formulate-input-element {
        padding: 0;
        background-color: transparent;
      }
      button {
        padding-left: 1.4rem;
        padding-right: 1.4rem;
      }
    }
  }
}
.visibility {
  position: absolute;
  right: 10px;
  top: 20px;
  font-size: 1rem;
  cursor: pointer;
}
</style>
